/* Own Orbit mobile sticky ATC: forwards to the native Shopify product form. */
(function () {
  'use strict';
  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll('#gen-product-information') : [];
    sections.forEach(function (section) {
      var bar = section.querySelector('[data-oo-mobile-atc]');
      if (!bar || bar.dataset.ooInitialized === 'true') return;
      bar.dataset.ooInitialized = 'true';
      var proxy = bar.querySelector('[data-oo-mobile-atc-button]');
      var label = bar.querySelector('[data-oo-mobile-atc-label]');
      var scheduled = false;

      function nativeButton() {
        return section.querySelector('.product-details product-form-component form button.add-to-cart-button');
      }
      function unselectedSize() {
        var group = section.querySelector('.product-details .variant-option[data-is-size-option="true"]');
        if (!group) return null;
        var selectedRadio = group.querySelector('input[type="radio"]:checked');
        var select = group.querySelector('select.variant-option__select');
        if (selectedRadio || (select && select.value)) return null;
        return group;
      }
      function sync() {
        if (!bar.isConnected) return;
        var original = nativeButton();
        if (!original) {
          bar.hidden = true;
          return;
        }
        var sizeGroup = unselectedSize();
        var soldOut = original.disabled && !sizeGroup;
        proxy.disabled = soldOut;
        if (sizeGroup) {
          label.textContent = 'Select size';
        } else {
          var nativeLabel = original.querySelector('.add-to-cart-text__content');
          label.textContent = (nativeLabel && nativeLabel.textContent.trim()) || (soldOut ? 'Sold out' : 'Add to cart');
        }
        // Hide only when the real button is fully visible above the fixed bar.
        // This avoids two primary calls-to-action occupying the viewport at once.
        var bounds = original.getBoundingClientRect();
        var visibleHeight = bar.getBoundingClientRect().height || 80;
        var shopNow = section.querySelector('.product-details .oo-shop-now--inline');
        var shopNowBounds = shopNow ? shopNow.getBoundingClientRect() : bounds;
        var nativeVisible = bounds.width > 0 && bounds.height > 0 &&
          shopNowBounds.width > 0 && shopNowBounds.height > 0 &&
          Math.min(bounds.top, shopNowBounds.top) >= 0 &&
          Math.max(bounds.bottom, shopNowBounds.bottom) < window.innerHeight - visibleHeight - 6;
        bar.hidden = window.matchMedia('(min-width: 750px)').matches || nativeVisible;
      }
      function scheduleSync() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () { scheduled = false; sync(); });
      }
      proxy.addEventListener('click', function () {
        var sizeGroup = unselectedSize();
        if (sizeGroup) {
          sizeGroup.scrollIntoView({behavior: 'smooth', block: 'center'});
          var firstSize = sizeGroup.querySelector('input[type="radio"], select');
          if (firstSize) firstSize.focus({preventScroll: true});
          return;
        }
        var original = nativeButton();
        if (original && !original.disabled) original.click();
        scheduleSync();
      });
      var sectionObserver = new MutationObserver(scheduleSync);
      sectionObserver.observe(section.querySelector('.product-details') || section,
        {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'checked', 'aria-disabled']});
      window.addEventListener('scroll', scheduleSync, {passive: true});
      window.addEventListener('resize', scheduleSync, {passive: true});
      section.addEventListener('variant:update', scheduleSync);
      section.addEventListener('change', scheduleSync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
